import Modal from '@/shared/ui/Modal/Modal';
import React, { ReactElement } from 'react';
import useModalContext from '@/shared/hooks/useModalContext';
import { ModalStyleEnum } from '@/shared/enums/Modal';
import Typography from '@mui/material/Typography';
import { XMarkIcon } from '@heroicons/react/24/outline';

type Props = {};

const ModalManager : React.FC<Props> = () : ReactElement => {
    const {
        isModalOpen, modalView, modalStyle, modalClassName, modalInnerClassName, closeModal, modalTitle, isModalLocked,
    } = useModalContext();

    return (
        <Modal isOpen={isModalOpen} closeModal={closeModal} style={modalStyle ?? ModalStyleEnum.Normal} className={modalClassName} modalInnerClassName={`app-managed-modal ${modalInnerClassName ?? ''}`}>
            {
                modalTitle !== '' && <div className='app-modal-header mb-6 flex min-w-0 flex-row items-start justify-between gap-3 sm:mb-10 sm:min-w-[600px]'>
                    <Typography id='modal-modal-title' variant='h5' component='h2' className='min-w-0 break-words'>
                        {modalTitle}
                    </Typography>

                    <button type='button' aria-label='Zavřít dialog' disabled={isModalLocked} className='-mt-2 flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-full text-gray-600 hover:bg-gray-100 disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary' onClick={() => closeModal()}>
                        <XMarkIcon aria-hidden='true' className='h-7 w-7' />
                    </button>
                </div>
            }
            {modalTitle === '' && <span id='modal-modal-title' className='sr-only'>Dialogové okno</span>}

            {modalView}
        </Modal>
    );
};

export default ModalManager;
